import React, { useState } from "react"
import "./style.scss"
//import MeetWersel from "../cards/meetwersel"
import Button from "../elements/button/Button"
import RequestDemo from "../modals/requestdemo/RequestDemo"

const Solutions = ({ data, btnBg, btnColor }) => {
  const [showDemoModal, setShowDemoModal] = useState(false)
  const showModal = () => {
    setShowDemoModal(!showDemoModal)
  }
  return (
    <div className="solutions_section">
      {showDemoModal && <RequestDemo show={showDemoModal} onHide={showModal} />}
      <div className="top_section">
        <div className="item">
          <h1 className="header">{data.title}</h1>
          <p className="desc">{data.desc}</p>
          <Button
            style={{
              background: btnBg ? btnBg : "",
              color: btnColor ? btnColor : "",
            }}
            onClick={showModal}
          >
            Request Demo
          </Button>
        </div>
        <div className="item">
          <img src={data.bannerImage} alt="product" />
        </div>
      </div>
      {/* <MeetWersel
        title={data.subSectionTitle}
        platformText={data.platformText}
      /> */}
      <div className="overview_section">
        <h1 className="title">{data.overview}</h1>
        {data.overwiewList && (
          <ul>
            {data.overwiewList.map((item, index) => {
              return <li key={index}>{item}</li>
            })}
          </ul>
        )}
        <p className="text">{data.overviewText}</p>
      </div>
    </div>
  )
}

export default Solutions
